import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { Frame } from "@shopify/polaris";
import { Sidenav } from "./components/common/Sidenav";
import Settings from "./components/Settings";
import { Dashboard } from "./components/Dashboard";
import { GlobalRibbon } from "./components/common/GlobalRibbon";
import Header from "./components/common/Header";
import Products from "./components/Products";
import { Profile } from "./components/Profile";
import { Addprofile } from "./components/Addprofile";
import Listing from "./components/Listing";
import UnLinked from "./components/UnLinked";
import { Editprofile } from "./components/Editprofile";
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from "react";
import { Login } from "./components/Login";
import Setup from "./components/Setup";
import Plan from "./components/Plan";
import FAQ from "./components/FAQ";
import Footer from "./components/common/Footer";
import {EbayAccount} from "./components/EbayAccount";
 
 function AppWrapper() {
  const location = useLocation();
  const [localData, setLocalData] = useState(null);
  const [setup, setSetup] = useState("0");
  const [isAppReady, setIsAppReady] = useState(false); // ✅ New state
  const [isLogin, setIsLogin] = useState(true);
 
  console.log(location);
  
  useEffect(() => {
    const stored = localStorage.getItem("storeData");
    const setupStepFromStorage = localStorage.getItem("Setup");
 
    // console.log("appjs SetupStep -->", setupStepFromStorage);
 
    if (setupStepFromStorage) {
      setSetup(setupStepFromStorage);
    }
 
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setLocalData(parsed);
      } catch (err) {
        console.error("Failed to parse storeData:", err);
      }
    }else{
      if (location.pathname !== `${process.env.REACT_APP_BASE_URL}/`) {
        setIsLogin(false);
      }
    }
 
    // ✅ App is ready after localStorage is read (even if nothing is found)
    setIsAppReady(true);
  }, []);
    // console.log(location);
 
  let setUpDone = !(setup === "1" || setup === "2");

  if ((!isLogin || setUpDone === false) && location.pathname !== `${process.env.REACT_APP_BASE_URL}/` && location.pathname !== `${process.env.REACT_APP_BASE_URL}/Setup`) {
    return <Login />;
  }
 
  const hideLayout =
    location.pathname === "/login" ||
    (location.pathname === "/Setup" && !setUpDone) ||
    !setUpDone;
 
  // ✅ Block rendering until app is initialized
  if (!isAppReady) return null;
  let routes = (
    <Routes>
      <Route path={`${process.env.REACT_APP_BASE_URL}/login`} element={<Login />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/Setup`} element={setUpDone ? <Dashboard /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/ebayaccounts`} element={setUpDone ? <EbayAccount/> : <Dashboard />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}`} element={setUpDone ? <Dashboard /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/options`} element={setUpDone ? <Dashboard /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/Plan&Pricing`} element={setUpDone ? <Plan /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/products`} element={setUpDone ? <Products /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/profile`} element={setUpDone ? <Profile /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/addprofile/:sh_product_id`} element={setUpDone ? <Addprofile /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/addprofile/`} element={setUpDone ? <Addprofile /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/listing`} element={setUpDone ? <Listing /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/settings`} element={setUpDone ? <Settings /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/shopify_products`} element={setUpDone ? <UnLinked /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/Editprofile/:id`} element={setUpDone ? <Editprofile /> : <Setup />} />
      <Route path={`${process.env.REACT_APP_BASE_URL}/FAQ`} element={setUpDone ? <FAQ /> : <Setup />} />
      <Route path="*" element={setUpDone ? <Dashboard /> : <Setup />} />
    </Routes>
  );
 
  if (hideLayout || !isLogin) return routes;
 
  const logo = {
    width: 300,
    topBarSource: 'https://cp2.infoshoreapps.com/cp/assets/logo.png',
  };
  return (
    <Frame
    navigation={<Sidenav />}
    logo={logo}
    topBar={<Header userData={localData}/>}
    // globalRibbon={localData?.user?.plan === 0 ? <GlobalRibbon /> : null}
    >
      {routes}
        <Footer />
    </Frame>
  );
}
 
 
 
 
function App() {
  //Need to bypass the user if tempcode found
  window.location.href = 'https://cp2.infoshoreapps.com/cp/login';
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('tempcode');
  // console.log("tempcode", code);
  if(code){
  localStorage.setItem("tempcode", code) // Make this dynamic
  }
  if (code) {
    <Dashboard />
  }
  return (
    <>
      <Router>
        <AppWrapper />
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}
 
 
export default App;